import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
// import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { FinyearService, SeasonService } from "../../../services/index";
import * as commonActions from "../../../store/actions/common.actions";
import { AddEditSeasonComponent } from "./addEditSeason.component";
declare var google;

@Component({
  selector: "party-tab",
  // host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./season.component.html",
})
export class SeasonMasterComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  seasonList: any[];
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter: any;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "order_from",
    orderDir: "asc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    name: "",
    //company_id: 0
  };
  agentList$ = [];
  companyInfo: any = [];
  finyearCtrl: FormControl = new FormControl();
  finyearList = [];
  constructor(
    private finyearService: FinyearService,
    public store: Store<fromRootStore.State>,
    private seasonService: SeasonService,
    public toasterService: ToasterService
  ) {
    this.filter = {
      name: "",
      fin_id: 4,
    };
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;*/
  }

  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: false, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        summaryFunc: (cells) => "Sample",
      },
      {
        name: "Fin Year",
        prop: "finyear",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Season",
        prop: "season",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Order From Date",
        prop: "order_from_f",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Order To Date",
        prop: "order_to_f",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Sales From Date",
        prop: "sales_from_f",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
      {
        name: "Sales To Date",
        prop: "sales_to_f",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      // { name: 'Action', prop: 'sno', minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: this.editDeleteTemplate }
    ];

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
    this.LoadFinYearList();
  }

  // hotkeys(event) {
  //   if (this.active) {
  //     if (event.ctrl && event.keyCode === 13) {
  //       this.addEditSeason("Add", "");
  //     }
  //     if (event.keyCode === 27) {
  //       this.bsModalRef.hide();
  //     }
  //   }
  // }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getSeasonList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSeasonList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getSeasonList();
  }

  LoadFinYearList() {
    let that = this;
    this.finyearService.getFinYearList({}).then((res: any) => {
      that.finyearList = res.data;
      let fin = res.data[0];
      this.filterData.fin_id = fin["fin_id"];
      this.finyearCtrl.setValue(fin["fin_id"]);
      this.applyFilter();
    });
  }

  getSeasonList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      name: this.filter.name,
      fin_id: this.filter.fin_id,
      filter: JSON.stringify(this.filterData),
      // tabTitle: this.title
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.seasonService
      .getSeasonList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.seasonList = res.data;
      });
  }

  clearFilter(): void {
    this.filterData = {
      name: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getSeasonList();
  }


  addEditSeason(mode: string, row: any): void {
         
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getSeasonList();
    });

    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {

   tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD SEASON",
          title: "ADD SEASON",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "ADD SEASON",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
    // let that = this;
    // setTimeout(function () {
    //   that.filterPanel.close();
    // }, 10);

    // if (mode == "Add") {
    //   row = {
    //     season_id: "",
    //     fin_id: "",
    //     season: "",
    //     order_from: "",
    //     order_to: "",
    //     sales_from: "",
    //     sales_to: "",
    //   };
    // }

    // this.bsModalRef = this.modalService.show(AddEditSeasonComponent, {
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   //class:'modal-lg'
    // });
    // this.bsModalRef.content.title = mode + this.title + "Details";
    // this.bsModalRef.content.mode = mode;
    // this.bsModalRef.content.partydata = Object.assign({}, row);
    // (this.bsModalRef.content.tabID = this.tabID),
    //   (this.bsModalRef.content.tabTitle = this.title),
    //   this.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
    //     that.getSeasonList();
    //     if (this.title == "DesignStockComponent")
    //       this.store.dispatch(new commonActions.LoadAllParty());
    //     else this.store.dispatch(new commonActions.LoadAllCompany());
    //   });
  }
  finyearFn(season: number) {
    let list: any = [];
    let that = this;
    list = this.finyearList;

    let id = season && season ? season : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });

      this.filter.fin_id = id;
      return fitem["finyear"];
    }
    return "";
  }
  deleteSeason(row: any): void {
    row["tabTitle"] = this.title;
    let that = this;
    swal({
      title: "Are you sure to delete this " + this.title + "?",
      text:
        "You will not be able to recover this " +
        this.title +
        " [" +
        row["season"] +
        "]",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.seasonService
          .deleteSeason(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getSeasonList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        /*if (dismiss === 'cancel') {
              swal(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              )
            }*/
      }
    );
  }

  addEditDetails(mode: string): void {
    let row = {
      sp_id: 1,
      fin_id: 1,
      sales_target: 4000,
      order_per: 50,
      order_target: 8000,
      fin_year: "2015-2016",
    };
    let tabObj = {
      action: "NewTab",
      params: {
        tabParent: "Master",
        tabName: "PlandetailsMasterComponent",
        mode: mode,
        data: row,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/Season/season.component.ts